import styled from "styled-components";
import { Icon } from "../Main/styles";
import { Table } from "antd";
import {MobileCalVW} from "../../components/CalVW";

interface DBTableProps {
  border: string;
  color: string;
  IsMobile: boolean;
}

export const DBFilterWrapper = styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 2px 2px 8px 2px #74747476;
  padding: 28px;

  .ant-table-content {
    font-family: 'Pretendard';
    .ant-table-thead > tr > th {
      text-align: center;
    }
    .name, .tel, .date, .manager, .platform, .path {
      text-align: center;
    }
    .money {
      text-align: right;
    }
  }
  .ant-pagination {
    justify-content: center;
  }
`
export const DBFilterCheckboxArea = styled.div<{IsMobile:boolean}>`
  display: flex;
  flex-direction: ${(props) => props.IsMobile ? 'column' : 'row'};
  align-items: ${(props) => props.IsMobile ? 'start' : 'center'};
  justify-content: space-between;
`
export const DBFilterDateArea = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`
export const Checkboxs = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`
export const CheckboxUnit = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  label {
    font-size: 14px;
    font-weight: 500;
    user-select: none;
  }
`
export const CheckboxColor = styled.div`
  width: 16px;
  height: 16px;
`
export const GotoStatus = styled.button`
  padding: 8px 12px;
  color: #fff;
  font-family: 'Pretendard';
  background-color: #1F75D1;
  border-radius: 4px;
  border: none;
  display: flex;
  align-items: center;
  gap: 6px;
`
export const DateArea = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  label {
    font-weight: 500;
    min-width: 50px;
    user-select: none;
    text-align: center;
  }
  .ant-select-selector {
    font-family: 'Pretendard';
    min-width: 100px;
  }
`

export const DBTableBtn = styled.button<DBTableProps>`
  border-radius: ${(props) => props.IsMobile ? MobileCalVW(4) : "4px"};
  background-color: transparent;
  border: 1px solid ${props => props.border || 'black'};
  color: ${props => props.color || 'black'};
  padding:  ${(props) => props.IsMobile ? `${MobileCalVW(8)} ${MobileCalVW(12)}` : "8px 12px"};
  font-family: 'Pretendard';
  font-weight: 500;
  transition: all.3s;
  &:hover {
    background-color: ${props => props.border || 'black'};
    color: #fff;
  }
`

export const DBTableExcelBtn = styled.button<{IsMobile?:boolean}>`
  padding: ${(props) => props.IsMobile ? `${MobileCalVW(8)} ${MobileCalVW(12)}` : '8px 12px'};
  display: flex;
  align-items: center;
  gap: ${(props) => props.IsMobile ? MobileCalVW(4) : '4px'};
  color: green;
  background-color: #C0C0C0;
  font-family: 'Pretendard';
  font-weight: 600;
  font-size: ${(props) => props.IsMobile ? MobileCalVW(20) : '14px'};
  border: none;
  border-radius: ${(props) => props.IsMobile ? MobileCalVW(4) : '4px'};
  transition: all.3s;
  &:hover {
    background-color: green;
    color: #fff;
  }
`
export const DBTableResultTxt = styled.p<{IsMobile:boolean}>`
  margin-left: ${(props) => props.IsMobile ? '0' : '10px'};
  margin-top: ${(props) => props.IsMobile && MobileCalVW(10)};
  font-size: ${(props) => props.IsMobile ? MobileCalVW(25) : '16px'};
  font-weight: 500;
  color: #8b8a8a;
  span {
    font-size: ${(props) => props.IsMobile ? MobileCalVW(27) : '22px'};
    color: red;
    font-weight: 700;
  }
`
export const ShowWrapper = styled.div`
  border: 2px solid #437eff;
  background-color: #fafafa;
  position: absolute;
  width: 150px;
  display: flex;
  flex-direction: column;
  z-index: 9;
`
export const ShowBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #696969;
  padding: 6px 12px;
  border-bottom: 1px solid #d8d8d8;
  user-select: none;
  &:hover {
    background-color: #437eff;
    color: #fff;
  }
  &:first-child {
    cursor: auto;
    user-select: none;
    ${Icon} {
      cursor: auto;
    }
  }
  &:last-child, &:first-child {
    border-bottom: none;
  }
`
export const TableBtn = styled.button`
  padding: 4px 8px;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-family: Pretendard;
  &.addPay {
    background-color: transparent;
    border: 1px solid #26dad1;
    color: #26dad1;
    font-size: 14px;
    font-weight: 600;
    &:hover {
      background-color: #26dad1;
      color: #101010;
    }
  }
`
export const AddTable = styled(Table)`
  .ant-table-thead > tr > th {
    border-bottom: none;
  }
  .ant-table-tbody > tr > td {
    padding: 10px;
  }
  .ant-pagination {
    display: none;
  }
`